<template>
  <el-dialog
    :model-value="modelValue"
    title="Actualización de datos"
    width="900px"
    destroy-on-close
    @update:model-value="$emit('update:modelValue', $event)"
  >
    <el-alert
      v-if="bloqueadoPorPropuesta"
      style="margin-bottom: 16px"
      type="warning"
      show-icon
      :closable="false"
      title="Este documento ya posee una Propuesta asociada. Los cambios de versión son únicamente informativos y no pueden aplicarse."
    />

    <el-table
      :data="diferencias"
      :row-class-name="filaSeleccionadaClassName"
    >
      <el-table-column
        width="50"
        align="center"
      >
        <template #header>
          <el-checkbox
            :model-value="todosSeleccionados"
            :indeterminate="algunosSeleccionados"
            :disabled="bloqueadoPorPropuesta || diferencias.length === 0"
            @change="toggleTodos"
          />
        </template>
        <template #default="{ row }">
          <el-checkbox
            :model-value="estaSeleccionado(row.campo)"
            :disabled="bloqueadoPorPropuesta"
            @change="(checked) => toggleCampo(row.campo, checked)"
          />
        </template>
      </el-table-column>
      <el-table-column
        prop="campo"
        label="Campo"
      />
      <el-table-column
        prop="valorAnterior"
        label="Valor actual"
      />
      <el-table-column
        prop="valorNuevo"
        label="ET Vigente"
      />
    </el-table>

    <template #footer>
      <span class="dialog-footer">
        <el-button
          type="info"
          @click="$emit('update:modelValue', false)"
        >
          {{ bloqueadoPorPropuesta ? 'Cerrar' : 'Mantener valores actuales' }}
        </el-button>
        <template v-if="!bloqueadoPorPropuesta">
          <el-button
            type="primary"
            plain
            :disabled="camposSeleccionados.length === 0 || loading"
            @click="actualizarSeleccionados"
          >
            Actualizar seleccionados
          </el-button>
          <el-button
            type="primary"
            :disabled="loading || diferencias.length === 0"
            @click="actualizarTodos"
          >
            Actualizar todos con ET vigente
          </el-button>
        </template>
      </span>
    </template>
  </el-dialog>
</template>

<script setup>
import {
  computed,
  ref,
  watch,
} from 'vue';

const props = defineProps({
  modelValue: {
    type: Boolean,
    required: true,
  },
  diferencias: {
    type: Array,
    default: () => [],
  },
  bloqueadoPorPropuesta: {
    type: Boolean,
    default: false,
  },
  loading: {
    type: Boolean,
    default: false,
  },
});

const emit = defineEmits(['update:modelValue', 'update']);

const camposSeleccionados = ref([]);

watch(
  () => props.modelValue,
  (newVal) => {
    if (newVal) {
      camposSeleccionados.value = [];
    }
  },
);

const estaSeleccionado = (campo) => camposSeleccionados.value.includes(campo);

const filaSeleccionadaClassName = ({ row }) => (estaSeleccionado(row.campo) ? 'row-selected' : '');

const toggleCampo = (campo, checked) => {
  if (checked) {
    if (!estaSeleccionado(campo)) {
      camposSeleccionados.value = [...camposSeleccionados.value, campo];
    }
  } else {
    camposSeleccionados.value = camposSeleccionados.value.filter((c) => c !== campo);
  }
};

const todosSeleccionados = computed(
  () =>
    props.diferencias.length > 0 && camposSeleccionados.value.length === props.diferencias.length,
);

const algunosSeleccionados = computed(
  () => camposSeleccionados.value.length > 0 && !todosSeleccionados.value,
);

const toggleTodos = (checked) => {
  camposSeleccionados.value = checked ? props.diferencias.map((d) => d.campo) : [];
};

const actualizarSeleccionados = () => {
  emit('update', {
    actualizarTodos: false,
    camposAActualizar: [...camposSeleccionados.value],
  });
};

const actualizarTodos = () => {
  emit('update', {
    actualizarTodos: true,
    camposAActualizar: props.diferencias.map((d) => d.campo),
  });
};
</script>

<style scoped>
.dialog-footer {
  display: flex;
  justify-content: flex-end;
  gap: 10px;
}

:deep(.row-selected td) {
  background-color: #e1f3d8 !important;
}

:deep(.row-selected:hover td) {
  background-color: #d3edc4 !important;
}
</style>
